var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizationUserActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2873 14.3541V12.8702C32.2873 12.0831 31.9746 11.3282 31.418 10.7716C30.8615 10.215 30.1066 9.90234 29.3195 9.90234H24.8677C24.0806 9.90234 23.3257 10.215 22.7692 10.7716C22.2126 11.3282 21.8999 12.0831 21.8999 12.8702V14.3541",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0938 6.93564C28.7329 6.93564 30.0616 5.6069 30.0616 3.96782C30.0616 2.32874 28.7329 1 27.0938 1C25.4547 1 24.126 2.32874 24.126 3.96782C24.126 5.6069 25.4547 6.93564 27.0938 6.93564Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0254 37.6016V36.3516C20.0254 35.6885 19.762 35.0526 19.2932 34.5838C18.8243 34.115 18.1884 33.8516 17.5254 33.8516H13.7754C13.1123 33.8516 12.4765 34.115 12.0076 34.5838C11.5388 35.0526 11.2754 35.6885 11.2754 36.3516V37.6016",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 31.3516C17.0311 31.3516 18.1504 30.2323 18.1504 28.8516C18.1504 27.4709 17.0311 26.3516 15.6504 26.3516C14.2697 26.3516 13.1504 27.4709 13.1504 28.8516C13.1504 30.2323 14.2697 31.3516 15.6504 31.3516Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5444 37.6016V36.3516C31.5444 35.6885 31.281 35.0526 30.8122 34.5838C30.3434 34.115 29.7075 33.8516 29.0444 33.8516H25.2944C24.6314 33.8516 23.9955 34.115 23.5267 34.5838C23.0578 35.0526 22.7944 35.6885 22.7944 36.3516V37.6016",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1689 31.3516C28.5497 31.3516 29.6689 30.2323 29.6689 28.8516C29.6689 27.4709 28.5497 26.3516 27.1689 26.3516C25.7882 26.3516 24.6689 27.4709 24.6689 28.8516C24.6689 30.2323 25.7882 31.3516 27.1689 31.3516Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.064 37.6016V36.3516C43.064 35.6885 42.8006 35.0526 42.3317 34.5838C41.8629 34.115 41.227 33.8516 40.564 33.8516H36.814C36.1509 33.8516 35.515 34.115 35.0462 34.5838C34.5774 35.0526 34.314 35.6885 34.314 36.3516V37.6016",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6885 31.3516C40.0692 31.3516 41.1885 30.2323 41.1885 28.8516C41.1885 27.4709 40.0692 26.3516 38.6885 26.3516C37.3078 26.3516 36.1885 27.4709 36.1885 28.8516C36.1885 30.2323 37.3078 31.3516 38.6885 31.3516Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11957 29.144C5.41247 29.4369 5.88734 29.4369 6.18023 29.144L10.9532 24.3711C11.2461 24.0782 11.2461 23.6033 10.9532 23.3104C10.6603 23.0175 10.1854 23.0175 9.89254 23.3104L5.6499 27.553L1.40726 23.3104C1.11437 23.0175 0.639495 23.0175 0.346601 23.3104C0.0537083 23.6033 0.0537083 24.0782 0.346601 24.3711L5.11957 29.144ZM6.3999 28.6137C6.3999 19.2298 12.9591 10.6236 22.0256 7.94186L21.6002 6.50346C11.9129 9.36876 4.8999 18.5482 4.8999 28.6137H6.3999ZM33.9831 7.94207C40.9406 9.99236 46.4538 15.4965 48.624 22.1681L50.0505 21.7041C47.7295 14.5693 41.8463 8.69547 34.4071 6.50324L33.9831 7.94207Z",
    fill: "#444444"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9302 28.3118C49.6373 28.0189 49.1625 28.0189 48.8696 28.3118L44.0966 33.0847C43.8037 33.3776 43.8037 33.8525 44.0966 34.1454C44.3895 34.4383 44.8644 34.4383 45.1573 34.1454L49.3999 29.9028L53.6425 34.1454C53.9354 34.4383 54.4103 34.4383 54.7032 34.1454C54.9961 33.8525 54.9961 33.3776 54.7032 33.0847L49.9302 28.3118ZM28.1221 50.9122L28.1928 51.6588L28.1221 50.9122ZM48.6499 28.8421C48.6499 39.5357 40.8065 48.9581 28.0514 50.1655L28.1928 51.6588C41.6954 50.3806 50.1499 40.3319 50.1499 28.8421L48.6499 28.8421ZM28.0514 50.1655C17.6165 51.1533 8.73719 43.3023 6.3238 34.3067L4.87503 34.6954C7.44144 44.2614 16.8972 52.7281 28.1928 51.6588L28.0514 50.1655Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationUserActivity);
export default __webpack_public_path__ + "static/media/Organization User Activity .cc835dc46c7f29b827a9baf0e0cf0d03.svg";
export { ForwardRef as ReactComponent };